<template>
	<div class="viewreport_game">
		<cIndex></cIndex>
		<div class="viewreport">
			<h4>脑健康体检报告</h4>
			<img src="../assets/duihao.png" alt="图片">
			<ul>
				<li><span>{{gameReport.name}}</span>您好，您已完成本次脑体检测试</li>
				<li>测试套餐为<span>{{gameReport.tc}}</span>,{{gameReport.nengli}}。</li>
				<li>您的综合各项脑能力表现<span>{{gameReport.renzhi}}</span></li>
			</ul>
			<p class="viewreport-buttons">
				<a class="reportpage-button" @click="reportpage(gameReport)">查看完整报告</a>
				<b></b>
				<a class="reportpage-button button-over" @click="endReportpage()">结束检测</a>
			</p>
		</div>
	</div>
</template>
<script>
	import cIndex from '@/components/header'
	const components = {
		cIndex
	}
	export default {
		components: components,
		data() {
			return {
				gameReport: {},
			}
		},
		methods: {
			reportpage(gameReport) {
				if(gameReport.packageid == 6 && gameReport.bid == 2){
						window.open('/#/mechanismCard')
				}else if(gameReport.packageid == 1 && gameReport.bid == 1){
						window.open('/#/mechanismPrin')
				}else{
					window.open("/#/reportpage")
				}
			},
			endReportpage() {
				this.$router.push({
					path: '/mybaogao',
				})
			}
		}, 
		created() {
			this.$http.post(urls.urltest + "/game/getMyAssessReport.json", {
				eid:localStorage.getItem('eid'),
				token: localStorage.getItem('token')
			}).then(function(res) {
				console.log(res.body)
				this.gameReport = res.body;
			})
		}
	}
</script>
<style>
	.viewreport {
		width: 800px;
		height: 500px;
		background: #fff;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		box-shadow: 0 0px 4px #ccc;
		text-align: center;
	}
	
	.viewreport img {
		padding-top: 61px;
	}
	
	.viewreport h4 {
		font-size: 16px;
		color: #555555;
		height: 64px;
		line-height: 64px;
		border-bottom: 1px solid #eee;
		text-align: center;
		box-sizing: border-box;
	}
	
	.viewreport ul {
		padding: 40px 0;
		line-height: 32px;
	}
	
	.viewreport ul li {
		text-align: center;
	}
	
	.reportpage-button {
		display: inline-block;
		width: 120px;
		height: 35px;
		background: #01BCD4;
		color: #fff;
		text-align: center;
		line-height: 35px;
		font-size: 14px;
		margin: 0 auto;
		cursor: pointer;
	}
	
	.reportpage-button:hover {
		color: #fff;
	}
	
	.viewreport-buttons .button-over {
		background: #467DE5;
	}
	
	.viewreport-buttons b {
		display: inline-block;
		width: 30px;
	}
</style>


// WEBPACK FOOTER //
// viewreport.vue?4b768e70